import React from 'react'
import './Fac.css'

const FAQAccordian = ({ containerObject, dataZone, templateName, contentId }) => {
   
    var content = containerObject;
    
    var accordianContent = content.FAQAccordian

    return (
        <>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row faq-accordian faq-title-style`}>
        <span className={`faqShippingInformationMt ${content.attributes.horizontalLine ? content.attributes.horizontalLine :"" }`}> </span>
        <h1  dangerouslySetInnerHTML={{ __html: content.containerTitle }}></h1>
            <div id={content.attributes.parentId}>

                 {content.FAQAccordian ?

                    content.FAQAccordian.map((item, index) => {
                       
                        return (

                            <>

                                <div class={`accordion accordion-flush ${containerObject.attributes.titleCSS}`} id={containerObject.attributes.articleId ?containerObject.attributes.articleId :""}>
                                    <div class="accordion-item m-3">
                                        <h2 class="accordion-header " id={`flush-headingOne_${index}`}>
                                            <button class="accordion-button collapsed button-color" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne_${item.attributes.faqId}`} aria-expanded="false" aria-controls="flush-collapseOne">
                                                <span dangerouslySetInnerHTML={{ __html: item.header }} className={`${item.attributes.faqHeadStyle}`}/>
                                                 </button>
                                        </h2>
                                        <div id={`flush-collapseOne_${item.attributes.faqId}`} class={`accordion-collapse  ${item.attributes.class} `} aria-labelledby="flush-headingOne" data-bs-parent={`#${containerObject.attributes.articleId}`}>
                                            <div class={`accordion-body ${item.attributes.faqBodyStyle}`} dangerouslySetInnerHTML={{ __html: item.body }}></div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        )
                    })

                    : ""}
            </div>
        </div>
        </>
    )
}
export default FAQAccordian